import './styles/globals.css'
import '@repo/ui/fonts'

import { scrubPii } from '@repo/pii-scrubber'
import * as Sentry from '@sentry/react'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { RouterProvider } from '@tanstack/react-router'
import React from 'react'
import ReactDOM from 'react-dom/client'

import { Toaster } from '@/components/ui/sonner'

import {
  initActionOutbox,
  startActionOutboxAutoFlush,
} from './lib/action-outbox-store'
import { initOutbox, startOutboxAutoFlush } from './lib/outbox-store'
import { setupPWA } from './lib/pwa'
import { QUERY_CACHE_MAX_AGE, queryPersister } from './lib/query-persist'
import { queryClient, router } from './router'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  enabled: import.meta.env.PROD && Boolean(import.meta.env.VITE_SENTRY_DSN),
  environment: 'production',
  sendDefaultPii: false,
  beforeSend(event) {
    return scrubPii(event)
  },
})

setupPWA()
startActionOutboxAutoFlush()
startOutboxAutoFlush()
void initActionOutbox()
void initOutbox()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={<p>Algo deu errado. Recarregue a página.</p>}
    >
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{
          persister: queryPersister,
          maxAge: QUERY_CACHE_MAX_AGE,
        }}
      >
        <RouterProvider router={router} />
        <Toaster position="top-center" />
      </PersistQueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)
